function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { isNotEmptyOrNull, resolveObj } from '@tecsinapse/es-utils/build';
import { isEmptyOrNull } from '@tecsinapse/es-utils';
export var INCLUDE_MATCH_CONST = 'INCLUDE';
export var EXACT_MATCH_CONST = 'EXACT';
export var normalizeString = function normalizeString(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};

var stringifyIfObject = function stringifyIfObject(value) {
  return _typeof(value) === 'object' ? JSON.stringify(value) : value;
};

export var resolveData = function resolveData(field, data) {
  return stringifyIfObject(resolveObj(field, data));
};
export var exportToCSV = function exportToCSV(fileName, columns, data) {
  var delimeter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ';';
  var fileNameWithExt = fileName;

  if (!fileNameWithExt.endsWith('.csv')) {
    fileNameWithExt = fileNameWithExt.concat('.csv');
  }

  var exportedColumns = columns.filter(function (_ref) {
    var _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options;
    return options["export"] === undefined || options["export"];
  });
  var dataToExport = data.map(function (d) {
    return exportedColumns.map(function (c) {
      return c.customRender ? c.customRender(d) : resolveData(c.field, d);
    }).join(delimeter);
  });
  dataToExport.splice(0, 0, exportedColumns.map(function (c) {
    return c.title;
  }).join(delimeter));
  var csvData = dataToExport.join('\n');
  var csvFile = window.URL.createObjectURL(new Blob(["\uFEFF", csvData], {
    type: 'text/csv;charset=utf-8;'
  }));

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(csvFile, fileNameWithExt);
  } else {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = csvFile;
    hiddenElement.target = '_blank';
    hiddenElement.download = fileNameWithExt;
    hiddenElement.style.visibility = 'hidden';
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  }
};
export var onChangeHeaderFilter = function onChangeHeaderFilter(setFilters) {
  return function (headerFilters) {
    setFilters(function (prevFilters) {
      var newFilters = {
        page: 0
      };
      newFilters.headerFilters = _objectSpread({}, headerFilters);
      return _objectSpread(_objectSpread({}, prevFilters), newFilters);
    });
  };
};
export var onChangeSortFilter = function onChangeSortFilter(setFilters) {
  return function (field, defaultSort) {
    setFilters(function (prevFilters) {
      var newFilters = {};

      if (field !== prevFilters.sortField) {
        // changing the sort column
        newFilters.sortField = field;
        newFilters.ascending = defaultSort ? defaultSort === 'ASC' : prevFilters.ascending;
      } else {
        // same sort column, change only order
        newFilters.ascending = !prevFilters.ascending;
      }

      return _objectSpread(_objectSpread({}, prevFilters), newFilters);
    });
  };
};
export var onChangeStartStopIndex = function onChangeStartStopIndex(setFilters) {
  return function (_ref2) {
    var startIndex = _ref2.startIndex,
        stopIndex = _ref2.stopIndex;
    var loadedResolver;
    var loadedPromise = new Promise(function (resolve) {
      loadedResolver = resolve;
    });
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevFilters), {
        startIndex: startIndex,
        stopIndex: stopIndex,
        loadedResolver: loadedResolver
      }), {}, {
        page: Math.round(startIndex / prevFilters.rowsPerPage)
      });
    });
    return loadedPromise;
  };
};
export var onChangePage = function onChangePage(setFilters) {
  return function (rowsPerPage, page) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {
        page: page,
        rowsPerPage: rowsPerPage
      });
    });
  };
};
export var initializeColumns = function initializeColumns(tableColumns, tableOptions, actions) {
  var columns = _toConsumableArray(tableColumns);

  if (tableOptions.selection) {
    columns.splice(0, 0, {
      field: 'checkbox-header',
      selection: true
    });
  }

  var hasActions = isNotEmptyOrNull(actions);

  if (hasActions) {
    columns.push({
      field: 'actions',
      actions: actions
    });
  }

  return columns;
};
export var isRemoteData = function isRemoteData(data) {
  return typeof data === 'function';
};
export var initializeFilters = function initializeFilters(pagination, rowsPerPageOptions, rowsPerPageProp, pageProp) {
  var toolbarOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var sortFuncInit = arguments.length > 5 ? arguments[5] : undefined;
  var advancedFiltersProp = toolbarOptions.advancedFilters;
  var headerFilters = {};
  var advancedFilters = {};
  var rowsPerPage = null;

  if (pagination) {
    rowsPerPage = rowsPerPageOptions.includes(rowsPerPageProp) ? rowsPerPageProp : rowsPerPageOptions[0];
  }

  if (advancedFiltersProp) {
    advancedFiltersProp.filters.forEach(function (_ref3) {
      var type = _ref3.type,
          filterValue = _ref3.value,
          name = _ref3.name;
      var value = '';

      if (filterValue) {
        value = filterValue;
      } else if (type === 'multi-select') {
        value = [];
      } else if (type === 'checkbox') {
        value = false;
      }

      advancedFilters[name] = value;
    });
  }

  return {
    headerFilters: headerFilters,
    advancedFilters: advancedFilters,
    page: pageProp,
    rowsPerPage: rowsPerPage,
    ascending: true,
    sortField: '',
    sortFunc: sortFuncInit,
    // TODO: Remove page/rowsPerPage logic to start stop index.
    // they have the same meaning, but the start/stop is used by
    // react-virtualized being easier to make as default than page logic
    startIndex: 0,
    stopIndex: rowsPerPage,
    loadedResolver: null
  };
};
export var applyHeaderFilters = function applyHeaderFilters(data, headerFilters, ascending, sortField, sortFunc) {
  var filteredSortData = _toConsumableArray(data); // Filter


  Object.keys(headerFilters).forEach(function (field) {
    var _headerFilters$field = headerFilters[field],
        filterValue = _headerFilters$field.value,
        matchType = _headerFilters$field.matchType;
    filteredSortData = filteredSortData.filter(function (row) {
      var valueField = resolveObj(field, row);

      if (!filterValue) {
        return true;
      }

      if (_typeof(valueField) === 'object') {
        return true;
      }

      if (typeof valueField === 'string') {
        if (matchType === EXACT_MATCH_CONST) {
          return valueField === filterValue;
        }

        return normalizeString(valueField).includes(normalizeString(filterValue));
      }

      return false;
    });
  }); // Sort when it has clicked in a sorted column

  if (sortField) {
    filteredSortData = sortFunc(filteredSortData, sortField, ascending);
  }

  return filteredSortData;
};
export var initializeSortFunc = function initializeSortFunc(sortFuncProp) {
  if (sortFuncProp !== undefined) {
    return sortFuncProp;
  }

  return function (copyData, field, ascending) {
    var sortedArray = copyData.sort(function (obj1, obj2) {
      var value1 = resolveData(field, obj1);
      var value2 = resolveData(field, obj2);

      if (value1 < value2) {
        return -1;
      }

      if (value1 > value2) {
        return 1;
      }

      return 0;
    });

    if (ascending) {
      return sortedArray;
    }

    sortedArray.reverse();
    return sortedArray;
  };
};

var isRowSelected = function isRowSelected(selectedRows, row, rowId) {
  return isNotEmptyOrNull(selectedRows) && selectedRows.some(function (selectedRow) {
    return rowId(selectedRow) === rowId(row);
  });
};

export var handleRowClick = function handleRowClick(rowData, hasSelection, onSelectRow, onRowClick, selectedRows, setSelectedRows, rowId) {
  return function (event) {
    if (onRowClick) {
      onRowClick(rowData);
      return;
    }

    if (!hasSelection) {
      return;
    }

    var checked = false;

    if (isEmptyOrNull(selectedRows)) {
      var newSelectedRows = [rowData];
      setSelectedRows(newSelectedRows);
      checked = true;

      if (onSelectRow) {
        onSelectRow(newSelectedRows, rowData, checked);
      }
    } else {
      var _newSelectedRows = [];

      if (isRowSelected(selectedRows, rowData, rowId)) {
        _newSelectedRows = selectedRows.filter(function (selectedRow) {
          return rowId(selectedRow) !== rowId(rowData);
        });
      } else {
        _newSelectedRows = [].concat(_toConsumableArray(selectedRows), [rowData]);
        checked = true;
      }

      setSelectedRows(_newSelectedRows);

      if (onSelectRow) {
        onSelectRow(_newSelectedRows, rowData, checked);
      }
    }
  };
};